function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
var DiagonalCropContainer = styled.div.attrs({
  style: function style(props) {
    return {
      width: props.width,
      height: props.height
    };
  }
})(_templateObject());
export default DiagonalCropContainer;